import React from 'react';
import { PAGE_TEXT } from './lang';

export const AppFooter: React.FunctionComponent = () => {
  return (
    <div className="app-footer bg-[#9B9B9B] pl-8 pr-8 pt-4 pb-4 text-white w-full z-[1200] overscroll-none text-sm">
      <div className="mx-auto">
        <div className="flex align-items justify-between mb-4">
          <a
            className="text-white underline text-xs"
            href="https://www.polyu.edu.hk/aradm/eadmission/PICS_applicant.pdf"
            target="_blank"
            rel="noreferrer"
          >
            {PAGE_TEXT.PICS}
          </a>
          <a
            className="text-white underline text-xs"
            href="https://www.polyu.edu.hk/privacy-policy-statement"
            target="_blank"
            rel="noreferrer"
          >
            {PAGE_TEXT.PPS}
          </a>
          <a
            className="text-white underline text-xs"
            href="https://www.polyu.edu.hk/aradm/eadmission/EEA.pdf"
            target="_blank"
            rel="noreferrer"
          >
            {PAGE_TEXT.NAEEA}
          </a>
          <a
            className="text-white underline text-xs"
            href="https://www.polyu.edu.hk/aradm/eadmission/PICS_for_PRC_applicant.pdf"
            target="_blank"
            rel="noreferrer"
          >
            {PAGE_TEXT.PROTECTION_LAW}
          </a>
        </div>
        <div className="text-xs">
          {PAGE_TEXT.SUPPORT}
          <a className="text-white" href={`mailto:${PAGE_TEXT.EMAIL}`}>
            {PAGE_TEXT.EMAIL}
          </a>
        </div>
        <div className="text-xs">
          {PAGE_TEXT.COPYRIGHT} {new Date().getFullYear()} {PAGE_TEXT.HKPU}
        </div>
      </div>
    </div>
  );
};
